
import Modal from '~/components/Modal.vue'
export default {
  name: 'CartFaq',
  components: { Modal },
  data() {
    return {
      activeFaq: {}
    }
  },
  computed: {
    faqs(){
      return this.$t('shop.cart.faq')
    }
  }
}
